import ListModel from '@/dex-shared/models/ListModel';

export default class AdminListModel extends ListModel {
  constructor(list: any, getters: any) {
    super(list, getters);
  }

  static get __typename(): string {
    return ListModel.__typename;
  }

  static get __types(): string[] {
    return ListModel.__types;
  }

  get viewLink(): string {
    return `/lista/${this.id}`;
  }

  get editLink(): string {
    return `/editar_lista/${this.id}`;
  }
}
